import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const officeService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    OFFICE: 'offices',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            company: filter?.company,
            office_type: filter?.officeType,
            location: filter?.location,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.OFFICE}`, request);
}

export function store (data) {
    const formData = new FormData();
    formData.append(`name`, data.name);
    if (data.locationUUID) formData.append(`location_uuid`, data.locationUUID);
    if (data.officeTypeUUID) formData.append(`office_type_uuid`, data.officeTypeUUID);
    if (data.operationHours) formData.append(`operation_hours`, data.operationHours);
    if (data.phoneCode) formData.append(`phone_code`, data.phoneCode);
    if (data.phoneNumber) formData.append(`phone_number`, data.phoneNumber);
    if (data.phoneIso) formData.append(`phone_iso`, data.phoneIso);
    if (data.image instanceof File) formData.append('image', data.image);
    (data.companyUUIDs ?? []).filter(item => item).forEach(item => {
        formData.append(`company_uuids[]`, item);
    });

    return apiHelper(API_URL).post(`/${MODULE.OFFICE}`, formData);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.OFFICE}/${uuid}`);
}

export function update (data) {
    const formData = new FormData();
    formData.append(`_method`, 'PUT');
    formData.append(`name`, data.name);
    if (data.locationUUID) formData.append(`location_uuid`, data.locationUUID);
    if (data.officeTypeUUID) formData.append(`office_type_uuid`, data.officeTypeUUID);
    if (data.operationHours) formData.append(`operation_hours`, data.operationHours);
    if (data.phoneCode) formData.append(`phone_code`, data.phoneCode);
    if (data.phoneNumber) formData.append(`phone_number`, data.phoneNumber);
    if (data.phoneIso) formData.append(`phone_iso`, data.phoneIso);
    if (data.image instanceof File) formData.append('image', data.image);
    (data.companyUUIDs ?? []).filter(item => item).forEach(item => {
        formData.append(`company_uuids[]`, item);
    });

    return apiHelper(API_URL).post(`/${MODULE.OFFICE}/${data.uuid}`, formData);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.OFFICE}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.OFFICE}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.OFFICE}/${data.uuid}`);
}
